import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useApi, PERMS } from "./api";

const Ctx = createContext(null);
export const useApp = () => useContext(Ctx);

export function AppProvider({ children }) {
  const api = useApi();
  const [state, setState] = useState({ me: null, branches: [], settings: null, error: null });
  const [branchId, setBranchIdRaw] = useState(localStorage.getItem("zil_branch") || "");

  const reload = useCallback(async () => {
    try {
      const me = (await api.get("/me")).data;
      if (me.role === "pending") return setState((s) => ({ ...s, me }));
      const [b, s] = await Promise.all([api.get("/branches"), api.get("/settings")]);
      setState({ me, branches: b.data, settings: s.data, error: null });
    } catch (e) {
      setState((s) => ({ ...s, error: e }));
    }
  }, [api]);

  useEffect(() => {
    reload();
  }, [reload]);

  const branches = state.branches;
  const valid = branches.find((b) => b.id === branchId);
  const effectiveBranch = valid ? branchId : state.me?.branch_id || branches[0]?.id || "";
  const setBranchId = (id) => {
    localStorage.setItem("zil_branch", id);
    setBranchIdRaw(id);
  };
  const can = (cap) => !!state.me && (PERMS[cap] || []).includes(state.me.role);
  return <Ctx.Provider value={{ ...state, api, reload, branchId: effectiveBranch, setBranchId, can }}>{children}</Ctx.Provider>;
}
